// extracted by mini-css-extract-plugin
export default {"product":"styles_product__Qsb2r","list-order-details":"styles_list-order-details__9A0TO","product-text":"styles_product-text__UolRa","surprise":"styles_surprise__AvSqv"};